import { BodyMicro } from '#/components/Text/BodyMicro';
import { useI18n } from '#/i18n/hooks/useI18n';
import { ListingStatusLabel } from '#/modules/listing/components/ListingStatusLabel/ListingStatusLabel';
import type { DatetimeString } from '#/types/TypedDateString';
import { useLocalDateStringFn } from '#/utils/string/datetime/convertDatetimeString';
import { shortDate } from '#/utils/string/datetime/dateString';

type Props = {
  status: 'ACTIVE' | 'INACTIVE';
  created: DatetimeString;
};

export function SearchHitApplicationStatus({ status, created }: Props) {
  const { i18n, locale } = useI18n();
  const { localDateString } = useLocalDateStringFn();

  return (
    <>
      <ListingStatusLabel listingStatus={status} asTag forceSolid />

      <BodyMicro>
        {i18n('Applied %(date)s', {
          date: shortDate(localDateString(created), {
            locale,
            yearFormat: 'long',
          }),
        })}
      </BodyMicro>
    </>
  );
}
